import React from 'react';
import { apiFetch } from '../../services/api';

// Email-capture section near the bottom of HomePage. Self-contained
// — its own POST handler hits /api/newsletter/subscribe and uses
// DOM lookups (form.elements / querySelector) to flip the button
// label and status message. The handler stays inline; lifting it to
// a hook would force component-state for what's already 12 lines
// of imperative DOM control.
export default function NewsletterSection() {
  return (
    <section className="asg-newsletter" id="newsletter">
      <div className="asg-newsletter-inner asg-reveal">
        <p className="asg-section-label">Stay in the Loop</p>
        <h2 className="asg-newsletter-title">New ranges, sales &amp; tips - sent occasionally.</h2>
        <p className="asg-newsletter-sub">Be the first to hear when we launch a new pergola, drop seasonal fabric colours, or run a sale. No spam, unsubscribe anytime.</p>
        <form
          className="asg-newsletter-form"
          onSubmit={async (e) => {
            e.preventDefault();
            const form = e.currentTarget;
            const email = form.elements.namedItem('email').value;
            const btn = form.querySelector('button');
            const msg = form.querySelector('.asg-newsletter-msg');
            btn.disabled = true;
            btn.textContent = 'Subscribing…';
            try {
              const res = await apiFetch('/api/newsletter/subscribe', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ email, source: 'home-hero' }),
              });
              if (res.ok) {
                msg.textContent = "Thanks - you're on the list.";
                msg.className = 'asg-newsletter-msg asg-newsletter-msg--ok';
                form.reset();
              } else {
                msg.textContent = 'Something went wrong. Try again in a moment.';
                msg.className = 'asg-newsletter-msg asg-newsletter-msg--err';
              }
            } catch (err) {
              msg.textContent = 'Network error. Try again in a moment.';
              msg.className = 'asg-newsletter-msg asg-newsletter-msg--err';
            }
            btn.disabled = false;
            btn.textContent = 'Subscribe';
          }}
        >
          <input type="email" name="email" required placeholder="you@example.com" aria-label="Email address" />
          <button type="submit" className="asg-btn-primary">Subscribe</button>
        </form>
        <p className="asg-newsletter-msg" aria-live="polite"></p>
      </div>
    </section>
  );
}
